(function () {
  "use strict";

  var RESULTS = {
    protection: {
      title: "Protection",
      body: "You are seeking a quiet boundary between your inner world and external noise. Based on your answers, we matched you to pieces designed as a daily anchor for steadiness—not a guarantee, but a tactile reminder that your energy is yours to protect.",
      bullets: ["Personal boundary · Subtle daily wear", "Quiet luxury metals & stones", "Matched to your sign & intention"],
      cta: "Shop Your Protection Match",
      url: "/collections/intention-protection",
    },
    calm: {
      title: "Calm",
      body: "Your chart points toward stillness and a gentler rhythm. These pieces support a wind-down ritual and a calmer mind—mindfulness jewelry, not medical treatment.",
      bullets: ["Tactile anchor for busy days", "Freshwater pearl & soft sparkle", "Evening-friendly, understated design"],
      cta: "Shop Your Calm Match",
      url: "/collections/intention-calm",
    },
    abundance: {
      title: "Abundance",
      body: "You are aligned with growth, openness, and quiet confidence. Your match highlights designs that catch light as a reminder of momentum and worth—not a promise of guaranteed outcomes.",
      bullets: ["Light-catching CZ & symbols of flow", "Stackable, everyday abundance", "Pre-designed, intention-forward styling"],
      cta: "Shop Your Abundance Match",
      url: "/collections/intention-abundance",
    },
    love: {
      title: "Love",
      body: "The stars show a readiness to open your heart—whether to invite connection, deepen bonds, or cultivate self-compassion. Matched to your sign & intention, this piece serves as a daily reminder that you are worthy of connection.",
      bullets: ["Heart-centered focus", "Elemental harmony", "Artisan elegance"],
      cta: "Shop Your Love Match",
      url: "/collections/intention-love",
    },
    balance: {
      title: "Balance",
      body: "You are calling in equilibrium—grounded presence without rigidity. These pieces are matched to steady your day with quiet symmetry: wearable reminders that calm and clarity can coexist.",
      bullets: ["Grounded everyday wear", "Neutral metals & soft geometry", "Matched to your sign & intention"],
      cta: "Shop Your Balance Match",
      url: "/collections/intention-balance",
    },
    healing: {
      title: "Healing",
      body: "Your answers point toward gentle repair and release. Matched to your sign & intention, this piece offers a comforting physical anchor during transition—not a medical treatment.",
      bullets: ["Gentle frequency", "Tactile support", "Mindful craftsmanship"],
      cta: "Shop Your Healing Match",
      url: "/collections/intention-healing",
    },
  };

  function resolveIntention(answers) {
    var need = answers.q2;
    var quality = answers.q5;
    if (need === "1") return "protection";
    if (need === "2") return "calm";
    if (need === "3") return "abundance";
    if (quality === "4") return "healing";
    if (quality === "5") return "love";
    if (quality === "1") return "balance";
    if (quality === "2") return "calm";
    if (quality === "3") return "abundance";
    return "balance";
  }

  function initTeaQuiz(QUIZ, opts) {
    opts = opts || {};
    var stepsWrap = QUIZ.querySelector(".tea-quiz__steps-wrap");
    var steps = [].slice.call(QUIZ.querySelectorAll(".tea-quiz__step"));
    var progressBar = QUIZ.querySelector(".tea-quiz__progress-bar");
    var progressWrap = QUIZ.querySelector(".tea-quiz__progress");
    var resultEl = QUIZ.querySelector("[data-quiz-result]");
    var backBtn = QUIZ.querySelector("[data-quiz-back]");
    var nextBtn = QUIZ.querySelector("[data-quiz-next]");
    var introEl = QUIZ.querySelector("[data-quiz-intro]");
    var answers = {};
    var index = 0;

    if (!steps.length || !nextBtn) return null;

    function updateProgress() {
      var pct = ((index + 1) / steps.length) * 100;
      if (progressBar) {
        progressBar.style.width = pct + "%";
        progressBar.setAttribute("aria-valuenow", String(Math.round(pct)));
      }
    }

    function showIntro() {
      if (introEl) introEl.classList.add("is-active");
      if (stepsWrap) stepsWrap.classList.remove("is-active");
      if (progressWrap) progressWrap.hidden = true;
      if (backBtn) backBtn.hidden = true;
      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.disabled = false;
        nextBtn.textContent = opts.introCta || "Start quiz";
      }
      index = -1;
    }

    function showStep(i) {
      if (introEl) introEl.classList.remove("is-active");
      if (stepsWrap) stepsWrap.classList.add("is-active");
      if (progressWrap) progressWrap.hidden = false;
      steps.forEach(function (s, n) {
        s.classList.toggle("is-active", n === i);
      });
      index = i;
      updateProgress();
      if (backBtn) backBtn.hidden = index === 0;
      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.textContent = index === steps.length - 1 ? "See my match" : "Continue";
        nextBtn.disabled = !answers["q" + (index + 1)];
      }
    }

    function showResult(key) {
      var r = RESULTS[key];
      if (!r) return;
      if (stepsWrap) stepsWrap.classList.add("is-hidden");
      if (progressWrap) progressWrap.hidden = true;
      if (backBtn) backBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      resultEl.querySelector("[data-result-kicker]").textContent = "Your intention";
      resultEl.querySelector("[data-result-title]").textContent = r.title;
      resultEl.querySelector("[data-result-body]").textContent = r.body;
      resultEl.querySelector("[data-result-bullets]").innerHTML = r.bullets
        .map(function (b) {
          return "<li>" + b + "</li>";
        })
        .join("");
      var cta = resultEl.querySelector("[data-result-cta]");
      cta.textContent = r.cta;
      cta.href = r.url;
      var full = resultEl.querySelector("[data-result-full-quiz]");
      if (full) {
        if (opts.fromPopup) {
          full.href = "/pages/find-your-piece?intention=" + key + "&from=popup";
          full.hidden = false;
        } else {
          full.hidden = true;
        }
      }
      resultEl.classList.add("is-visible");
      if (typeof opts.onComplete === "function") opts.onComplete(key);
      if (!opts.fromPopup) resultEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    QUIZ.querySelectorAll(".tea-quiz__option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = btn.closest(".tea-quiz__step");
        var q = step.dataset.question;
        step.querySelectorAll(".tea-quiz__option").forEach(function (o) {
          o.classList.remove("is-selected");
        });
        btn.classList.add("is-selected");
        answers[q] = btn.dataset.value;
        nextBtn.disabled = false;
      });
    });

    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (index > 0) showStep(index - 1);
      });
    }

    nextBtn.addEventListener("click", function () {
      if (nextBtn.disabled) return;
      if (index === -1) {
        showStep(0);
        return;
      }
      if (index < steps.length - 1) {
        showStep(index + 1);
        return;
      }
      showResult(resolveIntention(answers));
    });

    if (introEl && opts.showIntro) showIntro();
    else showStep(0);

    return { reset: function () {
      Object.keys(answers).forEach(function (k) { delete answers[k]; });
      QUIZ.querySelectorAll(".tea-quiz__option").forEach(function (o) { o.classList.remove("is-selected"); });
      if (resultEl) resultEl.classList.remove("is-visible");
      if (stepsWrap) stepsWrap.classList.remove("is-hidden");
      if (introEl && opts.showIntro) showIntro();
      else showStep(0);
    }};
  }

  window.TEA_initQuiz = initTeaQuiz;

  document.querySelectorAll("[data-tea-quiz]:not([data-tea-quiz-popup-inner])").forEach(function (el) {
    initTeaQuiz(el, {});
  });
})();
